
var version = "1.0.3";
console.info(`Ver: ${version}`)
/*
* 各类通用参数
* 每个数值内各个KEY 的作用
* sort_num : 用来数组排序的,并非参数相关的数值
* id/value : 对应后台数据库的值
* name     : 前端用来显示的值
* 其他KEY可自定义
*
*/
class ParamClass extends Array {
	constructor(value){
		super()
		value.sort((a,b) => {
			if(isNaN(a.sort_num) || isNaN(b.sort_num)){
				if(!isNaN(a.sort_num) && !isNaN(b.sort_num)){
					return a.id - b.id
				}
			} else {
				return a.sort_num - b.sort_num
			}
			return 0
		})
		this.__protoArray__ = value
		for(var i=0; i< value.length; i++){
			this[i] = value[i];
		}
	}
	// 根据ID 查询name
	getName(id, defaultValue){
		for(var i=0; i< this.length; i++){
			if(this[i].id == id){
				return this[i].name
			}
		}
		return defaultValue
	}
	// 根据Name 查询id
	getId(name, defaultValue){
		for(var i=0; i< this.length; i++){
			if(this[i].name == name){
				return this[i].id
			}
		}
		return defaultValue
	}
	// 根据ID 查询完整数据
	getOption(id){
		for(var i=0; i< this.length; i++){
			if(this[i].id == id){
				return this[i]
			}
		}
		return {}
	}
	map(mapFunc){
		return new ParamClass(this.__protoArray__.map(mapFunc))
	}
	build(){
		return new ParamClass(this.__protoArray__)
	}
	filter(mapFunc){
		return new ParamClass(this.__protoArray__.filter(mapFunc))
	}
}
let Param = {
	memberListType: new ParamClass([
		{
			id:      1,
			sort_num:1,
			name:    "perman_list",
		},{
			id:      2,
			sort_num:2,
			name:    "tem_list_01",
		},{
			id:      3,
			sort_num:3,
			name:    "tem_list_02",
		},{
			id:      4,
			sort_num:4,
			name:    "tem_list_03",
		},{
			id:      5,
			sort_num:5,
			name:    "tem_list_04",
		// },{
		// 	id:      6,
		// 	sort_num:6,
		// 	name:    "tem_list_05",
		}
	]),
	typeAppr: new ParamClass([
		{
			id:      1,
			sort_num:1,
			name:    "person_active",
		}
	]),
	memberListState: new ParamClass([
		{
			id:      1,
			sort_num:1,
			name:    "white_list",
		},{
			id:      2,
			sort_num:2,
			name:    "black_list",
		}
	]),
	memberPersonType:new ParamClass([
		{
			id:      1,
			sort_num:1,
			name:    "normal",
		},{
			id:      2,
			sort_num:2,
			name:    "await_revw",
		}
	]),

	scaleSelect: new ParamClass([
		{
			id      : 1,
			sort_num: 1,
			name    : "1-49",
		},{
			id      : 2,
			sort_num: 2,
			name    : "50-99",
		},{
			id      : 3,
			sort_num: 3,
			name    : "100-199",
		},{
			id      : 4,
			sort_num: 4,
			name    : "200-499",
		},{
			id      : 5,
			sort_num: 5,
			name    : "500-999",
		},{
			id      : 6,
			sort_num: 6,
			name    : "1000-9999",
		},{
			id      : 7,
			sort_num: 7,
			name    : "more_10000",
			is_i18n : true,
		}
	]),
	industrySelect : new ParamClass([
		{
			id      : 1,
			sort_num: 1,
			name    : "it_server",
		},{
			id      : 2,
			sort_num: 2,
			name    : "manufa",
		},{
			id      : 3,
			sort_num: 3,
			name    : "life_server",
		},{
			id      : 4,
			sort_num: 4,
			name    : "school_educ",
		},{
			id      : 5,
			sort_num: 5,
			name    : "gaver",
		},{
			id      : 6,
			sort_num: 6,
			name    : "finan",
		},{
			id      : 7,
			sort_num: 7,
			name    : "enter_venu",
		},{
			id      : 8,
			sort_num: 8,
			name    : "medical",
		},{
			id      : 9,
			sort_num: 9,
			name    : "other_indust",
		},

	]),
	regClientLangType : new ParamClass([
		{
			id      : 1,
			sort_num: 1,
			name    : "en",
		},{
			id      : 2,
			sort_num: 2,
			name    : "zh-CN",
		},{
			id      : 3,
			sort_num: 3,
			name    : "cn-TW",
		},{
			id      : 4,
			sort_num: 4,
			name    : "de",
		}
	]),
	roleState: new ParamClass([ // 角色状态
		{
			id: 1,
			sort_num: 1,
			name: "open",
		},{
			id: 2,
			sort_num: 2,
			name: "disable",
		},
	]), // 角色状态
}

export default Param